<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="myModal">
        <div class="myModalContent">
            <div class="myModalClose">
                <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg"
                    @click="closeMyModal">
                    <path
                        d="M23.916 3.92651C21.9652 2.05199 19.4795 0.77528 16.7733 0.257842C14.0672 -0.259597 11.262 0.00548148 8.71265 1.01955C6.16331 2.03362 3.9843 3.75113 2.45122 5.95486C0.918141 8.15858 0.0998535 10.7495 0.0998535 13.4C0.0998535 16.0505 0.918141 18.6414 2.45122 20.8452C3.9843 23.0489 6.16331 24.7664 8.71265 25.7805C11.262 26.7945 14.0672 27.0596 16.7733 26.5422C19.4795 26.0247 21.9652 24.748 23.916 22.8735C26.531 20.3607 28 16.9531 28 13.4C28 9.84695 26.531 6.43935 23.916 3.92651V3.92651ZM20.6137 17.8125C20.7589 17.9329 20.8766 18.0808 20.9596 18.2468C21.0425 18.4129 21.089 18.5936 21.096 18.7777C21.103 18.9618 21.0704 19.1453 21.0002 19.3167C20.9301 19.4882 20.8239 19.6439 20.6883 19.7741C20.5527 19.9044 20.3906 20.0064 20.2121 20.0738C20.0336 20.1411 19.8426 20.1724 19.651 20.1657C19.4593 20.159 19.2712 20.1144 19.0983 20.0347C18.9254 19.955 18.7715 19.8419 18.6461 19.7025L14.0551 15.2955L9.45991 19.7025C9.33337 19.8377 9.1795 19.9468 9.00768 20.0231C8.83586 20.0993 8.64968 20.1412 8.46047 20.1462C8.27126 20.1511 8.08298 20.119 7.90709 20.0518C7.7312 19.9847 7.57138 19.8838 7.43736 19.7554C7.30335 19.627 7.19793 19.4738 7.12754 19.305C7.05714 19.1362 7.02324 18.9555 7.02789 18.7737C7.03255 18.5919 7.07566 18.413 7.15461 18.2477C7.23356 18.0825 7.34669 17.9344 7.48712 17.8125L12.0771 13.4025L7.48816 8.98851C7.35713 8.86439 7.25297 8.71661 7.18166 8.55366C7.11035 8.39072 7.07331 8.21583 7.07267 8.03907C7.07203 7.86231 7.1078 7.68718 7.17792 7.52376C7.24804 7.36034 7.35113 7.21186 7.48125 7.08687C7.61137 6.96188 7.76594 6.86286 7.93607 6.7955C8.1062 6.72814 8.28852 6.69378 8.47254 6.6944C8.65655 6.69502 8.83862 6.7306 9.00826 6.79909C9.17789 6.86759 9.33174 6.96765 9.46095 7.09351L14.0551 11.5025L18.6461 7.09351C18.7731 6.95862 18.9272 6.84995 19.0993 6.77411C19.2713 6.69828 19.4576 6.65686 19.6468 6.65239C19.836 6.64792 20.0242 6.68048 20.1999 6.7481C20.3756 6.81572 20.5352 6.91698 20.6688 7.04571C20.8025 7.17445 20.9075 7.32796 20.9774 7.49692C21.0474 7.66587 21.0808 7.84673 21.0756 8.02848C21.0704 8.21023 21.0268 8.38907 20.9474 8.55411C20.868 8.71916 20.7545 8.86695 20.6137 8.98851L16.0258 13.4025L20.6137 17.8125Z"
                        fill="#F2F2F2" />
                </svg>
            </div>
            <div class="myModalContentBody">
                <DocumentUpload v-if="GetModalContentCategory === 'all_upload'" />
                <SingleUpload
                    v-if="GetModalContentCategory === 'Pitch Deck' || GetModalContentCategory === 'Business Registration'"
                    :get-modal-content-category="GetModalContentCategory"
                    :get-modal-main-content="GetModalMainContent" />
                <FounderProfile v-if="GetModalContentCategory === 'Founder Profile'"
                    :get-modal-content-category="GetModalContentCategory"
                    :get-modal-main-content="GetModalMainContent" />
                <AcceptOrRejectRequest
                    v-if="GetModalContentCategory === 'accept' || GetModalContentCategory === 'reject'"
                    :get-modal-content-category="GetModalContentCategory"
                    :get-modal-content-value="getModalContentValue" />
            </div>
        </div>
    </div>
</template>

<script>
import DocumentUpload from './modalContent/uploadDocument.vue'
import SingleUpload from './modalContent/singleUpload.vue'
import FounderProfile from './modalContent/founderProfile.vue'
import AcceptOrRejectRequest from './modalContent/acceptOrRejectRequest.vue'
export default {
    components: { DocumentUpload, SingleUpload, FounderProfile, AcceptOrRejectRequest },
    props: {
        GetModalContentCategory: String,
        GetModalMainContent: Object,
        getModalContentValue: Object
    },
    methods: {
        closeMyModal() {
            this.$store.commit("set_show_modal", false)
        }
    }
}
</script>

<style scoped>
.myModal {
    position: fixed;
    z-index: 999;
    padding-top: 200px;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    overflow: auto;
    background-color: rgb(150, 147, 147);
    background-color: rgb(150, 147, 147, .4);
}

.myModalContent {
    background-color: #fefefe;
    margin: auto;
    margin-top: -100px;
    border-radius: 15px;
    width: 385px;
}

.myModalClose {
    display: flex;
    justify-content: end;
    padding: .2em;
    z-index: 999;
}

.myModalContentBody {
    padding: .2em;
}

.close_svg {
    background-color: black;
    color: black !important;
}
</style>